module.exports = __webpack_public_path__ + "img/4bcd5b5.jpg";